import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { debounce } from 'lodash';

interface FaqData {
    question: string;
    answer: string;
}

type FaqDataArray = FaqData[];

@Component
export class FaqContainer extends ThemeComponent {
    @Ref data!: HTMLScriptElement;
    @Ref searchContainer!: HTMLElement;
    @Ref searchInput!: HTMLInputElement;
    @Ref searchResultsContainer!: HTMLElement;


    faqData: FaqDataArray|null = null;

    init() {

        // Handle close events
        this.handleCloseEvents();

        const theme = document.body.getAttribute('data-theme') as string;
        if (theme === 'nova') {
            this.initCategoryHandlers();
        }
    }

    handleCloseEvents() {
        this.$listen(document.body, 'click', (e) => {
            const clickedElement = e.target as HTMLElement;
            if (this.searchContainer === clickedElement || this.searchContainer.contains(clickedElement)) {
                return;
            }
            this.searchContainer.classList.remove('is-active');
            document.body.classList.remove('overlay-active');
        });
    }

    // Nova Theme Additions
    initCategoryHandlers() {
        const categories = this.querySelectorAll('.faq__category-list__title');
        for (const category of categories) {
            this.$listen(category as HTMLElement, 'click', this.onCategoryClicked.bind(this));
        }
    }

    onCategoryClicked(event: MouseEvent) {
        const activeCategoryButton = this.querySelector('.faq__category-list__title--selected') as HTMLElement;
        const newActiveCategoryButton = event.target as HTMLElement;
        const categoryIndex = newActiveCategoryButton .getAttribute('data-cat-index');
        const oldActiveCategory = this.querySelector(`.faq__category-contents--selected`) as HTMLElement;
        const newActiveCategory = this.querySelector(
            `.faq__category-contents[data-cat-index='${categoryIndex}']`
        ) as HTMLElement;

        activeCategoryButton.classList.remove('faq__category-list__title--selected');
        newActiveCategoryButton.classList.add('faq__category-list__title--selected');
        oldActiveCategory.classList.remove('faq__category-contents--selected');
        newActiveCategory.classList.add('faq__category-contents--selected');
    }
}
